var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent"}},[_c('v-container',{staticClass:"py-4 py-lg-8"},[_c('v-row',{},_vm._l((_vm.user.assets),function(asset){return _c('InventoryCard',{key:asset.asset_id,attrs:{"asset":asset}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }